import React from 'react';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Button from '@amzn/meridian/button';
import Row from '@amzn/meridian/row';
import SearchField from '@amzn/meridian/search-field';
import ToggleFilterButton from 'src/components/shared/toggleFilterButton/toggleFilterButton';
import { setIsJobConfigFilterSheetOpen, setSearchField } from 'src/store/jobConfigPageSlice/jobConfigPageSlice';
import { useAppSelector } from 'src/store/store';

const TopOptions = ({ onClickExportSummary }: { onClickExportSummary: () => void }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { searchField } = useAppSelector((state) => state.jobConfigPage);

  // Return
  return (
    <Row widths={['fill', 'fit']} spacingInset="400 none" alignmentHorizontal="justify">
      <Row width={'grid-4'}>
        <SearchField
          value={searchField}
          onChange={(newSearchField) => dispatch(setSearchField(newSearchField))}
          placeholder="Search for..."
          onSubmit={() => {}}
        />
        <ToggleFilterButton
          data-testid="job-config__filter-sheet-btn"
          tooltipTitle="Open Job Configuration Filter"
          onClick={() => dispatch(setIsJobConfigFilterSheetOpen(true))}
        />
      </Row>
      <Button onClick={onClickExportSummary}>Export Jobs Summary</Button>
      <Button
        className="job-config__add-job"
        onClick={() => {
          navigate('/createNewJob');
        }}
      >
        Add Job
      </Button>
    </Row>
  );
};

export default TopOptions;
